module.exports = __webpack_public_path__ + "img/consultoria_9-16.5c1435e7.webp";